export enum PathConst {
    OAUTH_INIT = '/',
    AUTH = '/auth',
    AUTH_FAILURE = '/auth-failure',
    DASHBOARD = '/dashboard',
    ORDER = '/order'
}